import TaskStatuses from "../../enums/taskStatuses";
import TaskActions from "../../enums/TaskActions";
import backgroundTasksEventsEmitter from "./events/backgroundTasksEventsEmitter";
import { type ScormTask } from "./taskPool";

const tasks = {
  getFailed: (id: number, onClose: (id: number) => void): ScormTask => {
    backgroundTasksEventsEmitter.updateHandlerOnce(TaskActions.close, id, onClose);

    return {
      id,
      status: TaskStatuses.failed,
      percent: 100,
      indeterminate: false,
      canClose: true,
      isUploading: false,
      isUploaded: false,
    } as ScormTask;
  },

  getCanceled: (id: number, onClose: (id: number) => void): ScormTask => {
    backgroundTasksEventsEmitter.updateHandlerOnce(TaskActions.close, id, onClose);

    return {
      id,
      status: TaskStatuses.canceled,
      percent: 100,
      indeterminate: false,
      canClose: true,
      isUploading: false,
      isUploaded: false,
    } as ScormTask;
  },

  getUploadedSuccessfully: (id: number): ScormTask =>
    ({
      id,
      status: TaskStatuses.successful,
      label: "Uploaded successfully!",
      percent: 100,
      indeterminate: false,
      isUploading: false,
      isUploaded: true,
      canCancel: false,
    }) as ScormTask,

  getProcessing: (id: number): ScormTask => {
    backgroundTasksEventsEmitter.unsubscribeAll(TaskActions.close, id);
    return {
      id,
      status: TaskStatuses.inProgress,
      label: "Processing...",
      errorLabel: "SCORM processing failed!",
      percent: 0,
      indeterminate: true,
      canClose: false,
    } as ScormTask;
  },

  getReadyToPublish: (id: number, onClose: (taskId: number) => void): ScormTask => {
    backgroundTasksEventsEmitter.updateHandlerOnce(TaskActions.close, id, onClose);
    return {
      id,
      status: TaskStatuses.successful,
      label: "Ready to publish!",
      percent: 100,
      indeterminate: false,
      canClose: true,
    } as ScormTask;
  },

  getStarted: (id: string | number, title: string, onCancel?: () => void): ScormTask =>
    ({
      id,
      status: TaskStatuses.inProgress,
      title,
      label: "Uploading...",
      isUploading: true,
      canCancel: !!onCancel,
      onCancel,
    }) as ScormTask,
};

export default tasks;
